<ng-container *ngIf="visivel">
  <!-- Menu do rodapé no celular: o que o dono mais faz, no alcance do polegar. -->
  <div class="mc-barra-fundo" aria-hidden="true"></div>
  <nav class="mc-barra" aria-label="Menu do celular">
    <button type="button" [class.on]="naInicio && !folha" (click)="abraInicio()" [attr.aria-current]="naInicio ? 'page' : null">
      <i class="fe-home" aria-hidden="true"></i>Início
    </button>
    <button type="button" *ngIf="temModuloPedidos" [class.on]="emPedidos && !folha" (click)="abraPedidos()">
      <span class="mc-barra__badge" *ngIf="novosPedidos">{{novosPedidos > 99 ? '99+' : novosPedidos}}</span>
      <i class="fe-shopping-bag" aria-hidden="true"></i>Pedidos
    </button>
    <button type="button" *ngIf="exibirVender" [class.on]="folha === 'vender'" (click)="abraVender()">
      <i class="fe-plus-circle" aria-hidden="true"></i>Vender
    </button>
    <!-- Quem não vê vendas abre mesa o tempo todo e quase não edita produto: com mesas, a aba troca. -->
    <button type="button" *ngIf="funcaoMesas as mesas; else abaProdutos" [class.on]="noSalao && !folha" (click)="execute(mesas)">
      <i class="fe-square" aria-hidden="true"></i>Mesas
    </button>
    <ng-template #abaProdutos>
      <button type="button" *ngIf="funcaoCardapio as cardapio" [class.on]="noCardapio && !folha" (click)="execute(cardapio)">
        <i class="fe-book-open" aria-hidden="true"></i>Produtos
      </button>
    </ng-template>
    <button type="button" (click)="abraFuncoes($event)">
      <i class="fe-grid" aria-hidden="true"></i>Funções
    </button>
  </nav>

  <div class="mc-veu" *ngIf="folha" (click)="fecheFolha()" aria-hidden="true"></div>

  <div class="mc-folha" *ngIf="folha === 'vender'" role="dialog" aria-modal="true" aria-label="Vender">
    <div class="mc-puxador" aria-hidden="true"></div>
    <div class="mc-folha__topo">
      <h3>Vender</h3>
      <button type="button" class="mc-fechar" (click)="fecheFolha()" aria-label="Fechar"><i class="fe-x" aria-hidden="true"></i></button>
    </div>
    <p class="mc-folha__texto">Como o cliente está comprando?</p>
    <section class="mc-bloco">
      <button type="button" class="mc-linha" *ngFor="let porta of portasDeVenda" (click)="execute(porta.funcao)">
        <span class="mc-pastel" [ngClass]="'mc-p-' + porta.cor"><i [class]="porta.icone" aria-hidden="true"></i></span>
        <span class="mc-linha__txt"><b>{{porta.nome}}</b><span>{{porta.detalhe}}</span></span>
        <i class="fe-chevron-right mc-seta" aria-hidden="true"></i>
      </button>
      <button type="button" class="mc-linha" *ngIf="exibirLancarPontos" (click)="lancePontos()">
        <span class="mc-pastel mc-p-rosa"><i class="fe-gift" aria-hidden="true"></i></span>
        <span class="mc-linha__txt"><b>Lançar pontos de fidelidade</b><span>Pelo telefone do cliente</span></span>
        <i class="fe-chevron-right mc-seta" aria-hidden="true"></i>
      </button>
    </section>
  </div>
</ng-container>
